import { AvailabilitySlot } from './types/availability-interface'

interface GroupedAvailabilities {
  weekdaysSlots: AvailabilitySlot[]
  dateSpecificSlots: AvailabilitySlot[]
}

export const groupAvailabilities = (slots: AvailabilitySlot[]) => {
  return slots.reduce<GroupedAvailabilities>(
    (acc, slot) => {
      if (slot.dayOfWeek !== null) acc.weekdaysSlots.push(slot)
      if (slot.date !== null) acc.dateSpecificSlots.push(slot)
      return acc
    },
    { weekdaysSlots: [], dateSpecificSlots: [] },
  )
}
